import React from "react";
import "../Styles/four0four.css";

const FourOFour = () => {
    return (
        <div>
            <div className="error-container">
            <h1>404 ERROR</h1>
            <p>Sorry, That page does not exist</p>
            <img id="error-image" alt="404" src="https://i.imgur.com/JRd96AZ.png" />
            </div>
        </div>
    );
}

export default FourOFour;